import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationContainer, NotificationManager } from "react-notifications";
import InputMask from 'react-input-mask'
import "react-notifications/lib/notifications.css";
import logo from "assets/images/vibo_vibo-magenta-transparent.png";
import { Field, reduxForm, formValueSelector } from "redux-form";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress";
import * as actions from "actions";
import normalizePhone from "../../util/normalizePhone";
import Img from "../../assets/images/success2.png";
import { phoneMask } from '../../util/consts'


class Signup extends Component {
  componentDidMount() {
    this.props.changeVerify();
    const user = JSON.parse(localStorage.getItem("user-data"));

    if (user) {
      const checked =
        // eslint-disable-next-line no-nested-ternary
        this.props.initURL.indexOf("/admin") !== -1
          ? this.props.initURL
          : user.role.name === "Administrator" && isWebview()
          ? "/SuperAdminMobileScreen"
          : user.role.name === "Administrator"
            ? "/super-admin/businesses"
            : user.role.name === "Customer"
              ? "/"
              : user.role.name === "Public"
                ? "/access-denied"
                : "/admin/appointments";

      this.props.history.push(checked);
    }
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    const user = JSON.parse(localStorage.getItem("user-data"));

    if (user) {
      const checked =
        // eslint-disable-next-line no-nested-ternary
        this.props.initURL.indexOf("/admin") !== -1
          ? this.props.initURL
          : user.role.name === "Administrator" && isWebview()
          ? "/SuperAdminMobileScreen"
          : user.role.name === "Administrator"
            ? "/super-admin/businesses"
            : user.role.name === "Customer"
              ? "/"
              : user.role.name === "Public"
                ? "/access-denied"
                : "/admin/appointments";

      this.props.history.push(checked);
    }
  }

  onSubmit = formValues => {
    this.props.showLoader();
    const { appointmentData } = this.props;
    if (appointmentData != '') {
      formValues.appointmentData = appointmentData;
    }
    this.props.userSignup({
      ...formValues,
    });
  };

  userPhone = phonenumber => {
    console.log("TCL: Signup -> phonenumber", phonenumber);
    this.props.userPhone(normalizePhone(phonenumber));
  };

  renderPhoneInput = ({
    input,
    placeholder,
    name,
    className,
    type,
    classType,
    height,
    labelName,
    colName,
    required,
    meta: { touched, error },
  }) => (
      <div className={`${colName} col-12`}>
        <div className={`form-group ${classType}`}>
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <InputMask
            {...input}
            alwaysShowMask={false}
            mask={phoneMask}
            style={{ height }}
            className={className}
            id={name}
            name={name}
            placeholder={placeholder}
            type={type}
          />
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    )

  renderInput = ({
    input,
    placeholder,
    name,
    className,
    type,
    classType,
    height,
    labelName,
    colName,
    required,
    meta: { touched, error },
  }) => (
      <div className={`${colName} col-12`}>
        <div className={`form-group ${classType}`}>
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <input
            {...input}
            style={{ height }}
            className={className}
            id={name}
            name={name}
            {...input}
            placeholder={placeholder}
            type={type}
          />
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    );

  render() {
    document.body.classList.remove("ios-mobile-view-height");
    const { loader, showMessage, alertMessage } = this.props;
    return (
      <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="login-content">
          <div className="login-header border-bottom">
            <Link className="app-logo" to="/" title="Jambo">
              <img src={logo} alt="jambo" title="Vibo Vibo" />
            </Link>
          </div>

          <div className="login-form">
            <h2 className="text-center mb-4">Sign Up</h2>
            {this.props.isSuccess ? (
              <div style={{ textAlign: "center" }} className="mt-5 mb-5">
                <img src={Img} alt="Success" width="40" className="mb-2" />
                <label className="mb-3">
                  Thank you for signing up. Please check your email for an activation link.
                </label>
                <Link to="/login">Login</Link>
              </div>
            ) : (
                <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                  <Field
                    name="firstname"
                    component={this.renderInput}
                    placeholder="John"
                    type="text"
                    className="form-control form-control-md"
                    height="35px"
                    classType=""
                    labelName="vibo.employees.form.firstname"
                    required
                  />
                  <Field
                    name="lastname"
                    component={this.renderInput}
                    placeholder="John"
                    type="text"
                    className="form-control form-control-md"
                    height="35px"
                    classType=""
                    labelName="vibo.employees.form.lastname"
                    required
                  />
                  {/* <Field
                    name="phonenumber"
                    component={this.renderInput}
                    placeholder="+1 (000) 000-0000"
                    type="text"
                    className="form-control form-control-md"
                    height="35px"
                    normalize={normalizePhone}
                    classType=""
                    labelName="vibo.employees.form.phoneNumber"
                    required
                  /> */}
                  <Field
                    name='phonenumber'
                    component={this.renderPhoneInput}
                    placeholder="+1 (000) 000-0000"
                    type="text"
                    className="form-control form-control-md"
                    height="35px"
                    classType=""
                    labelName="vibo.employees.form.phoneNumber"
                    required
                  />
                  <Field
                    name="email"
                    component={this.renderInput}
                    placeholder="Email"
                    type="email"
                    className="form-control form-control-md"
                    height="35px"
                    classType=""
                    labelName="vibo.employees.form.email"
                    required
                  />
                  <Field
                    name="password"
                    component={this.renderInput}
                    placeholder="Password"
                    type="password"
                    className="form-control form-control-md"
                    height="35px"
                    classType=""
                    labelName="vibo.employees.form.password"
                    required
                  />
                  <div className="mt-1 mb-2 text-center">
                    {loader ? (
                      <CircularProgress />
                    ) : (
                        <button
                          // style={{ backgroundColor: "#EA33A6", color: "#fff" }}
                          className="btn btn-vibo2"
                          type="submit"
                        >
                          <IntlMessages id="vibo.component.login.signupText" />
                        </button>
                      )}
                  </div>
                </form>
              )}
          </div>
        </div>

        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const validate = formValues => {
  const errors = {};
  if (!formValues.firstname) {
    errors.firstname = "vibo.error.form.firstname";
  }
  // if (!formValues.title) {
  //   errors.title = "vibo.error.form.designation";
  // }
  if (!formValues.lastname) {
    errors.lastname = "vibo.error.form.lastname";
  }
  if (!formValues.email) {
    errors.email = "vibo.error.form.email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.email)) {
    errors.email = "vibo.error.form.validEmail";
  }
  if (!formValues.phonenumber) {
    errors.phonenumber = "vibo.error.form.phoneNumber";
  } else if (
    !/^([+]{1})([1]{1})([0-9]{3})([0-9]{3})([0-9]{4})$/g.test(
      `+${formValues.phonenumber.replace(/[^\d]/g, "")}`
    )
  ) {
    errors.phonenumber = "vibo.error.form.validPhoneNumber";
  }
  if (!formValues.password) {
    errors.password = "vibo.error.form.signup.password";
  }

  return errors;
};

Signup = reduxForm({
  form: "customerSignup",
  validate,
  touchOnChange: true,
  enableReinitialize: true,
  // config: true
})(Signup);

const mapStateToProps = ({ login, auth, modal }) => {
  const {
    email,
    password,
    loader,
    showMessage,
    alertMessage,
    verify,
    user,
    firstname,
    lastname,
    phonenumber,
    isSuccess,
  } = login;
  const { appointmentData } = modal;
  const { initURL } = auth;
  const initialValues = login;
  return {
    email,
    password,
    loader,
    showMessage,
    alertMessage,
    verify,
    user,
    initURL,
    firstname,
    lastname,
    phonenumber,
    initialValues,
    isSuccess,
    appointmentData
  };
};

const mapDispatchToProps = dispatch => ({
  userSignIn: payload => dispatch(actions.signIn(payload)),
  userSignup: payload => dispatch(actions.signUp(payload)),
  userFirstName: firstname => dispatch(actions.firstnameInput(firstname)),
  userPhone: phonenumber => dispatch(actions.phonenumberInput(phonenumber)),
  userEmail: email => dispatch(actions.emailInput(email)),
  userPassword: password => dispatch(actions.passwordInput(password)),
  showLoader: () => dispatch(actions.showLoader()),
  hideLoader: () => dispatch(actions.hideLoader()),
  hideMessage: () => dispatch(actions.hideMessages()),
  changeVerify: payload => dispatch(actions.changeVerify(payload)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Signup)
);



// WEBPACK FOOTER //
// ./components/Signup/index.js